import * as React from 'react';
import { Grid, Typography /* Button */ } from '@material-ui/core';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getLocalStorageValue } from 'src/effects/utils/local-storage';
import { UserType } from 'src/constants/Enum/UserType';

export default class SurveyReportsPageHeaderComponent extends React.Component<any, any> {
         static contextTypes = {
            router: PropTypes.object
        }
    
        state = {
            spacing: '16',
        };
    
        constructor(props: any) {
            super(props);          
        }
    
       
        render() {  
            const loggedInUser = getLocalStorageValue('user'); 
            return (
                <>
                    <div className="pageHeading">
                    <Grid container={true} spacing={8}>
                                    <Grid item={true} xs={9}>
                                        <div className="pageTitleSection">
                                            <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle strongText">
                                            NutriDash Reports
                                        </Typography>
                                        </div>
                                    </Grid>
                            <Grid item={true} xs={3}>
                                {
                                    loggedInUser.roleId === UserType.DataCollector ?
                                        <div className="dataEntryPage">
                                            <Link to={`/data-collector-dashboard`} > Go to Data Entry </Link>
                                        </div> : ''
                                }
                            </Grid>
                                </Grid>
                    </div>
                </>
            )
        }
    
    }
    


// WEBPACK FOOTER //
// ./src/components/reports/SurveyReportsPageHeaderComponent.tsx